import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div className='footer' data-aos="zoom-in-up">
            <div>
                <p>Emergency Care Of Patients</p>
                <p>Check Up</p>
                <p>Treatment of Personal Diseases</p>
                <p>Treatment Extractions</p>
                <p>Check Up</p>
            </div>
            <div>
                <h2 className='f-h1'>Services</h2>
                <p>Fluoride Treatment</p>
                <p>Corona Virus Treatment</p>
                <p>Cardiology</p>
                <p>Orthopedics Specialist</p>
                <p>Kidney Specialist</p>
            </div>
            <div>
                <h2 className='f-h1'>Policies</h2>
                <p>Personal Diseases</p>
                <p>Settings</p>
                <p>Cookies</p>
                <p>Treatment Extractions</p>
                <p>Check Up</p>
            </div>
            <div>
                <h2 className='f-h1'>Our Address</h2>
                <p>Dhaka Bangladesh - 1216 Dhanmondi-15</p>
                
            </div>
        </div>
    );
};

export default Footer;